module.exports = __webpack_public_path__ + "4ee025bfa743b2c39c1d1fd9a0919be3.jpeg";